import { useEffect, useState } from 'react';
import { subscribeInvoicingSettings } from '@/data/settingsRepo';
import {
  makeDefaultInvoicingSettings,
  missingInvoicingSettings,
  type InvoicingSettingsType,
} from '@/types/types_settings';

/**
 * Subscribes to the invoicing settings — the issuer and bank block every
 * invoice prints. Admin screens only; the rules refuse the document to anyone
 * else, and the error path below is what a partner would land in.
 *
 * Starts from the defaults for the same reason `useSiteSettings` does, and
 * hands back `missing` alongside them because here the defaults are explicitly
 * *not* enough to issue with — the bank account and the registration number
 * have no sensible default and must be typed in once.
 */
export function useInvoicingSettings() {
  const [settings, setSettings] = useState<InvoicingSettingsType>(makeDefaultInvoicingSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return subscribeInvoicingSettings(
      (next) => {
        setSettings(next);
        setLoading(false);
      },
      (e) => {
        console.error('Invoicing settings subscription failed', e);
        setLoading(false);
      },
    );
  }, []);

  return { settings, loading, missing: missingInvoicingSettings(settings) };
}
